import { AxiosInstance } from "axios";
import { IdDto } from "../types/id/id-dto";
import {
  LocationDto,
  LocationImagesDto,
  LocationPageDto,
} from "../types/location/location-dto";
import {
  CreateLocationPayload,
  SearchLocationPagePayload,
  UpdateLocationPayload,
} from "../types/location/location-payload";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

enum LocationApiUrl {
  Create = "/location",
  Update = "/location",
  GetById = "/location",
  Search = "/locations",
  UploadImages = "/location/upload-images",
}

class LocationApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async create(
    payload: CreateLocationPayload
  ): Promise<OngBaseResponse<IdDto>> {
    return await this._api.post(LocationApiUrl.Create, payload);
  }

  async update(
    id: string,
    payload: UpdateLocationPayload
  ): Promise<OngBaseResponse<IdDto>> {
    return await this._api.patch(LocationApiUrl.Update + `/${id}`, payload);
  }

  async getById(id: string): Promise<OngBaseResponse<LocationDto>> {
    return await this._api.get(LocationApiUrl.GetById + `/${id}`);
  }

  async search(
    payload: SearchLocationPagePayload
  ): Promise<OngBaseResponse<LocationPageDto>> {
    return await this._api.get(LocationApiUrl.Search, {
      params: payload,
    });
  }

  async uploadImages(
    formData: FormData
  ): Promise<OngBaseResponse<LocationImagesDto>> {
    return await this._api.put(LocationApiUrl.UploadImages, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export const locationApi = new LocationApi(ongBaseApi);
